import { useMemo } from "react";
import { useAccountData } from "../../../hooks/useAccountData";
import { Comic } from "../../../types";

/**
 * Hook to reactively determine if a comic is hidden from reading history
 * This hook is purely reactive and handles no mutations
 */
export function useIsComicHidden(comic: Comic): boolean {
  const accountData = useAccountData();
  const accountHiddenComics = accountData?.hidden_reading_history_comics || [];

  return useMemo(() => {
    return accountHiddenComics.includes(comic.id);
  }, [accountHiddenComics, comic.id]);
}